import {GestionCategorieDto, IGestionCatalogueWebServiceClient} from "@resources/resources";
import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";

@Injectable()
export class EnregistrementCategorieResolver implements Resolve<GestionCategorieDto> {

  constructor(private gestionCatalogueWebService: IGestionCatalogueWebServiceClient) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    let id = route.params['id'];
    return this.gestionCatalogueWebService.getCategorie(id);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/administration/categories/enregistrement/enregistrement.categories.resolver.ts